module.exports = __webpack_public_path__ + "static/media/36-7.854c5eb1.mp3";